import { PolicyDialog } from './policyDialog';
import consoleLogger from '../../logger/consoleLogger';
import { GameClient } from '../../gameClient/gameClient';
import { PreloaderScreen } from '../../gameClient/webgl/preloaderScreen';
import { Environment } from '../../environment/environment';
import { getBrowserName } from '../../utils/browser';
import { getUserSuid } from './getUserSuid';
import { GetUserError } from './getUserError';
import { Url } from './url';
import { Localization } from '../../localization/localization';
import { Stat } from '../../stat/Stat';
import { ClientJS } from 'clientjs';
import { UserFingerprint } from './userFingerpint/UserFingerprint';
import { NotificationsWrap } from './notifications/NotificationsWrap';
import { CurrentUser } from './user/currentUser';
import { isRetentionUser } from './appEvents';
import { CollectedRefsFactSender } from '../../marketing/collected-refs/collected-refs-fact-sender';
import { getMarketingData, getRetentionData, MarketingData } from './marketing/marketing';
import {
    GetGameStartDataRequest,
    GetGameStartDataResponse
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/get-game-start-data-request';
import { getUrlToLoginViaToken } from '../../login/getUrlToLoginViaToken';
import { addLoginQueryParams } from '../../utils/url';
import axios from 'axios';
import { getHubApi } from './accountServiceApi/getAccountServiceApi';
import { UserSession } from './user/userSession';

const logger = consoleLogger.getPrefixedCopy('GET_USER');

window.app.getGameStartDataResponse = null;

function getUserCity(): string {
    let cityRegexp: RegExp;
    let city: string;

    cityRegexp = new RegExp('^[а-яА-Я\\s-.()]{0,50}$|^[a-zA-Z\\s-.()]{0,50}$', 'i');
    city = $.trim(window.app.user.city);
    if ((cityRegexp.test(city)) !== true) {
        city = '';
    }

    return city;
}

function getUserName(): string {
    let name;
    const nameRegexp = new RegExp('^[а-яА-Я\\s]{0,30}$|^[a-zA-Z\\s]{0,30}$', 'i');
    name = window.app.user.full_name;

    if ((nameRegexp.test(name)) !== true) {
        name = '';
    }

    return name;
}

function buildGetUserRequest(marketingData: MarketingData): GetGameStartDataRequest {
    const userFingerPrint = new UserFingerprint(new ClientJS());
    const user = window.app.user;

    const req: GetGameStartDataRequest = {
        suid: getUserSuid(),
        cluster: window.app.config.cluster_name,
        is_web_request: true,
        token: window.app.config.user_auth_token,
        human_data: {
            deviceId: window.app.deviceIdentifier,
            current_entry_point: window.app.config.current_entry_point,
            ref: marketingData.ref,
            ref_p: window.app.config.ref_p,
            referrer: marketingData.referrer,
            browser: getBrowserName(),
            clientType: window.app.clientType,
            clientFamily: window.app.clientFamily,
            age: user.age,
            isMale: user.gender.toString(),
            city: getUserCity(),
            full_name: getUserName(),
            authOption: marketingData.authOption,
            client_id: UserSession.getInstance().getDeviceId(),
            fingerprintId: userFingerPrint.getId().toString(),
            firstWebVisitTs: userFingerPrint.getTs(),
            firstWebVisitRnd: userFingerPrint.getRnd(),
            attributionData: marketingData.attributionData
        }
    };

    if (marketingData.fbData) {
        req.human_data.fbUserData = {
            fbId: marketingData.fbData.fbId,
            fbp: marketingData.fbData.fbp,
            firstName: marketingData.fbData.firstName,
            lastName: marketingData.fbData.lastName,
        };
    }

    if (window.app.config.suid_simulate) {
        req.suid_simulate = window.app.config.suid_simulate;
    }

    return req;
}

const GET_USER_RETRY_DELAY = 100;

export async function getUser(): Promise<void> {
    // TODO Wtf, почему тут эта проверка?
    if (!window.app.isDesktop) {
        return;
    }

    try {
        if (window.app.getGameStartDataResponse) {
            return;
        }

        if (window.app.flags.user_ready) {
            const marketingResponse = await getMarketingData();
            const request = buildGetUserRequest(marketingResponse);

            try {
                const hubApi = getHubApi();

                const hubResponse = await hubApi.getGameStartData(
                    window.app.deviceIdentifier,
                    request
                );
                const result = hubResponse as GetGameStartDataResponse;

                const retentionData = await getRetentionData(
                    request.suid_simulate ? 1 : 0,
                    result.registerTs,
                    result.registration
                );
                if (retentionData) {
                    result.fdretention = retentionData.fdretention;
                    result.ret1 = retentionData.ret1;
                    result.ret7 = retentionData.ret7;
                }

                await loginWithNewToken(result.new_token, getUserSuid());

                handleGetUserSuccessResponse(result, result.new_token);
            } catch (error) {
                handleGetUserErrorResponse(error.message);
            }
        } else {
            setTimeout(function scheduleGetUserRetry() {
                console.log('window.app.getUser waiting window.app.flags.user_ready');
                getUser();
            }, GET_USER_RETRY_DELAY);
        }
    } catch (error) {
        window.Sentry.captureException(error);
        throw error;
    }
}

function handleGetUserSuccessResponse(response: GetGameStartDataResponse, newToken: string) {
    window.app.config.user_auth_token = newToken;
    window.app.user_huid = response.account.id;
    Stat.activate();
    window.app.config.sig_funnel = response.sig_funnel;
    window.app.config.user_realm = 0;
    if (response.realmID) {
        window.app.config.user_realm = response.realmID;
    }

    if (response.sig) {
        window.app.config.sig = response.sig;
    }

    window.app.config.stringGuid = '';
    if (response.stringGuid) {
        window.app.config.stringGuid = response.stringGuid;
    }

    logger.info('get_user', 'window.app.getUser | ready | ', response);

    if (response.registration === 1) {
        window.app.flags.first_registration = true;
        window.app.eventInstall();
    } else {
        window.app.notInstall();
    }

    isRetentionUser(response);

    window.app.getGameStartDataResponse = response;
    PolicyDialog.checkPolicyAccept();

    NotificationsWrap.startSession(CurrentUser.getInstance().getSuid()
        .toString());

    if (response.registration === 1) {
        const collectedRefsSender = new CollectedRefsFactSender(window.app.config.collectedRefs, Stat);
        collectedRefsSender.send();
    }
}

function handleGetUserErrorResponse(errorMessage: string|undefined) {
    window.app.flags.get_user_error = true;

    if (typeof errorMessage === 'undefined') {
        logger.error('Invalid get user response');
        throw new GetUserError('Invalid getuser response');
    }

    const isNotSpooferError = errorMessage.search(/not spoofer/) !== -1;
    if (isNotSpooferError) {
        PreloaderScreen.getInstance().hide();
        GameClient.hide();
        showNotSpoofer();
    }

    if (String(errorMessage).trim() === '0') {
        throw new GetUserError('Request was blocked');
    }

    throw new GetUserError(errorMessage);
}

function showNotSpoofer() {
    let link: string;
    let linkEl: JQuery;
    const $techWorks = $('#techworks');
    const $techWorksContent = $techWorks.find('#techworksh2');
    const $techWorksContent1 = $techWorks.find('#techworksh1');

    link = '';

    if (Environment.isSocial()) {
        link = window.app.config.app_url + window.app.config.social_app_id;
        linkEl = $('<a href="#">').on('click', function redirectToSocApp(event) {
            event.preventDefault();
            top.location.href = link;
        });
        linkEl.text(Localization._n('not_spoofer_goto'));
        $techWorksContent.text('');
        $techWorksContent.append(linkEl);
    } else {
        link = Url.getSiteNoLangUrl('');
        $techWorksContent.html(`<a href="${link}">${Localization._n('not_spoofer_goto')}</a>`);
    }

    $techWorksContent1.text(Localization._n('not_spoofer_error'));
    $techWorks.show();
}

export function isGetUserFinished() {
    const GET_USER_CHECK_TICK = 200;

    return new Promise<void>((resolve, reject) => {
        const getUserCheckInterval = setInterval(() => {
            if (window.app.flags.user_ready && window.app.flags.get_user_ready) {
                clearInterval(getUserCheckInterval);
                resolve();
                return;
            }

            if (window.app.flags.get_user_error) {
                clearInterval(getUserCheckInterval);
                reject(new GetUserError('Get user failed'));
            }
        }, GET_USER_CHECK_TICK);
    });
}

async function loginWithNewToken(token: string, suid: string) {
    let url = getUrlToLoginViaToken(token, suid);
    url = addLoginQueryParams(url);
    await axios.get(url);
}
